import { HomePage } from "../components"

export default HomePage
